export function getQueryParameters (url, paramCount) {
  const returnDetail = url.split('?')[1]
  const urlData = JSON.parse('{"' + decodeURI(returnDetail).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
  if (Object.keys(urlData).length !== paramCount) {
    return []
  }
  return urlData
}
